import React from "react";

function FilteredResultsContainer(props) {
  return props.showMe ? (
    <section className={`${props.itemType.toLowerCase()}s`}>
      {props.showHeader ? <h2>{`${props.itemType}s`}</h2> : ""}
      <ol className="collection collection-container">
        <li className="item item-container">
          <div className="attribute" data-name="">
            {`${props.itemType}`} Name
          </div>
          <div className="attribute" data-name={props.secondColumnName}>
            {props.secondColumnName}
          </div>

          <div className="attribute" data-name="Administrator">
            Administrator
          </div>
          <div className="attribute-container">
            <div className="attribute" data-name="Address and Map Link">
              Address
            </div>
            <div className="attribute" data-name="Other address"></div>
            <div className="attribute" data-name="City, State, Zip"></div>
          </div>
          <div className="attribute" data-name="Phone">
            Phone
          </div>
          <div className="attribute-container">
            <div
              className={`attribute ${props.itemType.toLowerCase()}-website`}
              data-name={`${props.itemType} Website`}
            >
              Links
            </div>
            <div
              className="attribute dashboard"
              data-name="Dashboard Report"
            ></div>
          </div>
        </li>
        {props.children}
      </ol>
    </section>
  ) : (
    ""
  );
}

export default FilteredResultsContainer;
